module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Technology Imagineer.901bfcf5.png";